import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { abbreviateMonth } from '../../lib/utils'

export const MomBooksGridY = () => {
  const { colors } = useTheme()
  const stats = useStats((s) => s.stats)
  const monthLength = stats?.mom_books_read?.results || []

  return (
    <FlexBox
      className={css`
        flex-shrink: 1;
        width: 22px;
        gap: 4px;
      `}
      flexDirection="column"
    >
      {monthLength.map((m, i) => (
        <FlexBox
          key={i}
          className={css`
            height: 36px;
          `}
          alignItems="center"
        >
          <Text
            type="label"
            sizing="S"
            color={m.count === 0 ? colors.uiWhite50 : colors.uiWhite}
            weight="500"
          >
            {abbreviateMonth(m.month)}
          </Text>
        </FlexBox>
      ))}
    </FlexBox>
  )
}
